import React, { useEffect } from 'react';
import ReactGA from 'react-ga4';
import CookieConsent, { Cookies } from 'react-cookie-consent';
import { Trans, useTranslation } from 'react-i18next';
import { useTheme } from '@mui/material';
import { googleAnalyticsConfig } from '../../state/googleAnalyticsConfig';

export const AcceptCookies = () => {
  const { t } = useTranslation();
  const theme = useTheme();

  useEffect(() => {
    // check if cookies was accepted previously.
    enableAnalytics();
  }, []);

  function enableAnalytics() {
    const consentGiven = Cookies.get('CookieConsent') === 'true';
    if (consentGiven) {
      ReactGA.initialize(googleAnalyticsConfig.trackingId);
    }
  }

  return (
    <CookieConsent
      buttonText={t('COOKIE_ACCEPT')}
      declineButtonText={t('COOKIE_DENY')}
      enableDeclineButton
      onAccept={() => {
        enableAnalytics();
      }}
      style={{
        background: theme.palette.text.primary,
        zIndex: 1202,
        color: theme.palette.primary.contrastText,
      }}
      buttonStyle={{
        color: theme.palette.text.primary,
        backgroundColor: theme.palette.primary.main,
        fontSize: '15px',
      }}
      declineButtonStyle={{
        color: theme.palette.text.primary,
        backgroundColor: theme.palette.secondary.main,
        fontSize: '15px',
      }}
    >
      <Trans
        i18nKey="COOKIE_MESSAGE"
        style={{ color: theme.palette.text.primary }}
      >
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://hitiq.com/cookie-policy"
          style={{ color: theme.palette.primary.main }}
        >
          placeholder_text
        </a>
      </Trans>
    </CookieConsent>
  );
};
